import { PathSegmentResolver } from '../../utils/use-path';

export const resolveSearchPath: PathSegmentResolver = ({ defaultLink }) => {
  return {
    title: 'Sök produkt',
    isPageTitle: true,
    link: defaultLink,
  };
};
